export default "__VITE_ASSET__C1tA4b8S__"